import axios from "axios";
import { i18n } from "../translations/i18n";

function getPortletURLPromise() {
    return new Promise(function(resolve, reject) {
        function waitForPortletURL() {
            if (typeof Liferay.PortletURL !== "undefined") {
                resolve();
            } else {
                setTimeout(waitForPortletURL, 100);
            }
        }
        waitForPortletURL();
    });
}

function getPortletResourceURLString(path, portletId) {
    let url = Liferay.PortletURL.createURL(Liferay.ThemeDisplay.getLayoutURL());
    url.setPortletId(portletId);
    url.setLifecycle(Liferay.PortletURL.RESOURCE_PHASE);
    url.setDoAsGroupId('true');
    url.setResourceId(path);
    url.setWindowState('normal');
    url.setPortletMode('view');
    url.setParameter('p_auth', Liferay.authToken);
    return url.toString();
}

/*
function getPortletActionURLString(path, portletId) {
    let url = Liferay.PortletURL.createURL(Liferay.ThemeDisplay.getLayoutURL());
    url.setPortletId(portletId);
    url.setLifecycle(Liferay.PortletURL.ACTION_PHASE);
    url.setDoAsGroupId('true');
    url.setWindowState('normal');
    url.setPortletMode('view');
    url.setParameter('p_auth', Liferay.authToken);
    url.setParameter('javax.portlet.action', path);
    return url.toString();
}
*/

export function get(path, portletId, params = null) {
    // wait until Liferay.PortletURL is initialized before using it
    let portletURLPromise = getPortletURLPromise();
    return portletURLPromise.then(function() {
        let urlParams = new URLSearchParams();
        urlParams.append('lang', i18n.locale)
        if (params !== null) {
            for (let prop in params) {
                if (params[prop] instanceof Array) {
                    let values = params[prop].flat(5)
                    urlParams.append(prop, values.join())
                } else {
                    urlParams.append(prop, params[prop])
                }
            }
        }
        const url = getPortletResourceURLString(path, portletId)
        return axios.get(url,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                params: urlParams,
                timeout: 60000
            }
        );
    })

}
export function postWithBlobResponse(path, portletId, data) {
    const headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/octet-stream'
    }
    const responseType = 'blob'
    const timeout = 120000 // 2 mins
    return doPost(path, portletId, data, headers, responseType, timeout)
}

export function post(path, portletId, data) {
    const headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
    const responseType = 'json'
    return doPost(path, portletId, data, headers, responseType)
}

function doPost(path, portletId, data, headers, responseType, timeout = 30000) {
    let portletURLPromise = getPortletURLPromise();

    return portletURLPromise.then(function() {
        const url = getPortletResourceURLString(path, portletId)
        let urlParams = new URLSearchParams();
        urlParams.append('lang', i18n.locale)
        return axios.post(
            url,
            data,
            {
                headers: headers,
                timeout: timeout,
                responseType: responseType,
                params: urlParams
            }
        );
    });

}
